<div class="AdminContainer Flexbox Flexbox--column Gap--normal">
  <table>
    <thead>
      <th>Form</th>
      <th>Inside Material</th>
      <th>Design Material</th>
    </thead>
    <tbody>
      <tr>
        <td>
          <select [ngModel]="form()" (ngModelChange)="form.set($event)">
            <option [ngValue]="null"></option>
            @for (form of forms(); track $index) {
              <option [ngValue]="form">{{ form.displayName }}</option>
            }
          </select>
        </td>
        <td>
          <select [ngModel]="insideMaterial()" (ngModelChange)="insideMaterial.set($event)">
            <option [ngValue]="null"></option>
            @for (material of insideMaterials(); track $index) {
              <option [ngValue]="material">{{ material.displayName }}</option>
            }
          </select>
        </td>
        <td>
          <select [ngModel]="outsideMaterial()" (ngModelChange)="outsideMaterial.set($event)">
            <option [ngValue]="null"></option>
            @for (material of outsideMaterials(); track $index) {
              <option [ngValue]="material">{{ material.displayName }}</option>
            }
          </select>
        </td>
      </tr>
    </tbody>
  </table>

  <div class="FilesContainer ControlGroup Flexbox Flexbox--column Gap--smaller">
    <div class="ControlGroupContent Flexbox Flexbox--column Gap--smaller">
      <div class="Control Flexbox Justify--space-between gap--normal">
        <span>Design Textures</span>
        <input type="file" name="textures" accept="image/*" multiple (change)="textureFilesChange($event)">
      </div>
    </div>
  </div>

  <table>
    <thead>
      <th>Texture Width</th>
      <th>Max Ring Width</th>
    </thead>
    <tbody>
      @for (widthMapping of widthMappings(); track $index; let index = $index) {
        <tr>
          <td>
            <div class="Flexbox Justify--center">
              <select [ngModel]="widthMapping.textureWidth" (ngModelChange)="textureWidthMappingChanged($event, index)">
                @for (width of widths(); track $index) {
                  <option [value]="width.value">{{ width.displayName }}</option>
                }
              </select>
            </div>
          </td>
          <td>
            <div class="Flexbox Justify--center">
              <select [ngModel]="widthMapping.ringWidth" (ngModelChange)="ringWidthMappingChanged($event, index)">
                @for (width of widths(); track $index) {
                  <option [value]="width.value">{{ width.displayName }}</option>
                }
              </select>
            </div>
          </td>
        </tr>
      }
    </tbody>
    <tfoot>
      <tr>
        <td>
          <div class="Flexbox Justify--center">
            <select [ngModel]="newTextureWidth()" (ngModelChange)="newTextureWidth.set(+$event)">
              <option [value]="null"></option>
              @for (width of widths(); track $index) {
                <option [value]="width.value">{{ width.displayName }}</option>
              }
            </select>
          </div>
        </td>
        <td>
          <div class="Flexbox Justify--center">
            <select [ngModel]="newRingWidth()" (ngModelChange)="newRingWidth.set(+$event)">
              <option [value]="null"></option>
              @for (width of widths(); track $index) {
                <option [value]="width.value">{{ width.displayName }}</option>
              }
            </select>
          </div>
        </td>
      </tr>
      <tr>
        <td>
          <button (click)="widthSaveButtonClick()">Save</button>
        </td>
      </tr>
    </tfoot>
  </table>
</div>
